<template>
	<div class="news">
		<div class="news-box">
			<div class="title">{{ detail.title }}</div>
			<div class="sub">
				<span>{{ detail.pushDate }}</span>
				<span>{{ detail.mediaChannel }}</span>
			</div>
			<div class="info" v-html="detail.internalInfo"></div>
			<div class="page">
				<div class="item">
					<div v-if="prv" @click="prev()">
						<img style="margin-right: 8px;" src="@/assets/images/arrow_left.png" />
						<span>上一篇：</span>
						<span>{{ prv.title }}</span>
					</div>
				</div>
				<div class="item">
					<div v-if="next" @click="handleNext()">
						<span>下一篇：</span>
						<span>{{ next.title }}</span>
						<img style="margin-left: 8px;" src="@/assets/images/arrow_right.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { queryInfoFromH5, queryNextOrPre } from '@/axios/api.js'
export default {
	data() {
		return {
			detail: {},
			prv: undefined,
			next: undefined,
		}
	},
	created() {

		this.init(this.$route.query.id, this.$route.query.nodeNum)

	},
	mounted() {

	},
	computed: {},
	watch: {},
	methods: {
		init(id, nodeNum) {
			this.detail = {}
			this.prv = undefined
			this.next = undefined

			let params = {
				id,
				tab: this.$route.query.tab,
				nodeNum,
			}
			queryInfoFromH5(params).then(res => {
				this.detail = res.data.data

				// 上一个
				if (this.detail.pageNum > 1) {
					let params1 = {
						pageNum: this.detail.pageNum - 1,
						tab: this.$route.query.tab,
					}
					queryNextOrPre(params1).then(res1 => {
						this.prv = res1.data.data
					})
				}


				// 下一个
				// todo
				let params2 = {
					pageNum: this.detail.pageNum + 1,
					tab: this.$route.query.tab,
				}
				queryNextOrPre(params2).then(res2 => {
					this.next = res2.data.data
				})
			})
		},

		prev() {
			if(this.prv.jumpType === 'OUT_LINK'){
				window.open(this.prv.outLink)
			}else{
				this.init(this.prv.id, this.prv.pageNum)
			}
		},

		handleNext() {
			if(this.next.jumpType === 'OUT_LINK'){
				window.open(this.next.outLink)
			}else{
				this.init(this.next.id, this.next.pageNum)
			}
		}
	},
	beforeDestroy() {

	},
	components: {

	}
}
</script>

<style scoped lang="less">
.news-box {
	padding: 120px 0 60px 0;
	background: #EEF5FE url('../../assets/images/news_bg.png') top center no-repeat;
	background-size: 100% auto;
	box-sizing: border-box;
	min-height: calc(100vh - 57px);
	display: flex;
	flex-direction: column;
	align-items: center;

	.title {
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 16px
	}

	.sub {
		margin-bottom: 30px;

		span {
			padding: 0 10px;
			font-size: 14px;
			color: #AEB3C0;
		}
	}

	.info {
		width: 1178px;
	}

	::v-deep .info img {
		max-width: 1178px;
		display: block;
		margin: 0 auto;
	}
}

.page {
	padding-top: 70px;
	width: 1178px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.item {
		cursor: pointer;
		
		
		div{
			display: flex;
			align-items: center;
		}

		img {
			width: 22px;
			height: auto;
		}

		span {
			color: #24242A;
			font-size: 18px;
			font-weight: bold;
		}
	}
}
</style>